import React from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid2';
import CircularProgress from '@mui/material/CircularProgress';

const Results = ({ result, loading }) => {
  return (
    <Box>
      <Grid container>
        <Grid size={12}>
          <h4>{result.title}</h4>
        </Grid>
        <Grid size={12}>
          {loading ? (
            <Box style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '50px' }}>
              <CircularProgress size={24} />
            </Box>
          ) : (
            <>
              <p className="bq-results-status" style={{ color: result.color }}>
                {result.status}
              </p>
              <ul className="bq-results-items">
                {(result.items || []).map((reasonText, index) => (
                  <li key={index}>{reasonText}</li>
                ))}
              </ul>
            </>
          )}
        </Grid>
        <Grid size={12}>
          <p>{result.message}</p>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Results;